module.exports = __webpack_public_path__ + "static/media/Identity-how.a6e30f50.mp4";